<header>
  <h2>{{ 'taxReturns.Archived-Configurations' | transloco }}</h2>
</header>
<div class="doc-container">
  <app-navigation></app-navigation>
  <app-folder-view></app-folder-view>
</div>